import { postReqAuth } from '../../api';

export const getAllEnrollments = (data, cb) => postReqAuth('/webapi/student/course-enrollment/get/all', data, '', cb);


export const followupEnrollment = (data ,cb) =>
	postReqAuth("/webapi/student/course-enrollment/update", data, "", cb);